import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IdName, ToastService} from '@core/src/public-api';
import {InsuranceAddItem} from '@shared/models/insurance.model';
import {LoginService} from '@shared/services/login.service';
import {ProfileService} from '@shared/services/profile.service';

@Component({
  selector: 'si-health-insurance-add-button',
  templateUrl: './health-insurance-add-button.component.html',
  styleUrls: ['./health-insurance-add-button.component.scss']
})
export class HealthInsuranceAddButtonComponent {
  @Input() openDialogButton = true;
  @Input() openDialogButtonDisabled: boolean;
  @Output() onSucessAddInsurance = new EventEmitter<IdName>();
  model = new InsuranceAddItem();
  displayDialog: boolean;
  displayErrorDialog: boolean;

  constructor(
    private profileService: ProfileService,
    private toastService: ToastService,
    private loginService: LoginService
  ) { }

  onClickButtonAddInsurance(): void {
    this.model = new InsuranceAddItem();
    this.displayDialog = true;
  }

  onClickAddInsurance(): void {
    this.addPatientInsurance();
  }

  async addPatientInsurance(): Promise<void> {
    try {
      this.model.collectiveId = this.model.collective.id;
      await this.profileService.addPatientInsurance(this.model);
      this.toastService.success('SI_INSURANCE_ADD_SUCCESS');
      this.loginService.setPreferredCollectiveId(this.model.collectiveId);
      this.onSucessAddInsurance.emit(this.model.collective);
    } catch (e) {
      if (e.error?.applicationCode === 'PCS0011') {
        this.displayErrorDialog = true;
      }

      throw e;
    }
  }
}
